import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import UpdateMediaCommand from './updatemediacommand';

export default class UpdateMediaUI extends Plugin {

  init() {
    this.editor.commands.add('updatemedia', new UpdateMediaCommand(this.editor));
  }
}